import React, { useState, useEffect } from 'react';
import api from '../services/api';
import { FiX, FiFileText } from 'react-icons/fi';

const NoteSelectionModal = ({ onClose, onSelect }) => {
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchNotes = async () => {
      try {
        const response = await api.get('/notes');
        const textOnlyNotes = response.filter(note => {
          if (!note.fileUrl) return true;
          const url = note.fileUrl.toLowerCase();
          return !['.jpg', '.jpeg', '.png', '.webp'].some(ext => url.endsWith(ext));
        });
        setNotes(textOnlyNotes);
      } catch (err) {
        console.error('Error fetching notes:', err);
        setError('Failed to load notes library.');
      } finally {
        setLoading(false);
      }
    };

    fetchNotes();
  }, []);

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-container" onClick={(e) => e.stopPropagation()} style={{ maxWidth: '600px', maxHeight: '80vh', display: 'flex', flexDirection: 'column' }}>
        <div className="modal-header">
          <h3>Select a Note to Summarize</h3>
          <button className="btn btn-ghost btn-sm" onClick={onClose}>
            <FiX size={18} />
          </button>
        </div>

        <div style={{ padding: '8px 0', overflowY: 'auto', flex: 1 }}>
          {loading ? (
            <div className="text-center p-4"><div className="spinner mx-auto"></div><p className="mt-2 text-secondary">Loading notes...</p></div>
          ) : error ? (
            <div className="alert alert-error">{error}</div>
          ) : notes.length === 0 ? (
            <div className="empty-state"><p>No text/PDF notes found in your college library.</p></div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              {notes.map(note => (
                <div
                  key={note._id}
                  onClick={() => onSelect(note)}
                  style={{
                    padding: '14px 16px',
                    borderRadius: 'var(--radius-md)',
                    background: 'var(--bg-surface-hover)',
                    border: '1px solid var(--border-subtle)',
                    cursor: 'pointer',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    transition: 'all 150ms ease'
                  }}
                  className="note-selection-item"
                >
                  <div style={{
                    width: '36px',
                    height: '36px',
                    borderRadius: 'var(--radius-sm)',
                    background: 'var(--primary-light)',
                    color: 'var(--primary)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '18px'
                  }}>
                    <FiFileText />
                  </div>
                  <div style={{ flex: 1 }}>
                    <h4 style={{ margin: '0 0 2px 0', color: 'var(--text-primary)', fontSize: '14px', fontWeight: '600' }}>{note.title}</h4>
                    <p style={{ margin: 0, color: 'var(--text-secondary)', fontSize: '12px' }}>
                      {note.subject} • Sem {note.semester} • {note.type === 'pastpaper' ? 'Past Paper' : 'Note'}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default NoteSelectionModal;
